import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  CanLoad,
  Router
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { tap, filter, take, switchMap, catchError, map } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { AuthenticationService } from '../../authentication/authentication.service';

import * as fromStore from '../store';

@Injectable()
export class AccountBlockGuard
  implements CanActivate, CanActivateChild, CanLoad {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private store: Store<fromStore.AccountState>
  ) {}

  public canActivate(): Observable<boolean> {
    if (this.authenticationService.isLoggedInAsPartner()) {
      return of(true);
    } else {
      return this.checkStore().pipe(
        switchMap(() => {
          const hasManagerAccess: Observable<boolean> = this.store.select(
            fromStore.getHasManagerAccess
          );
          return hasManagerAccess;
        }),
        map((hasManagerAccess: boolean) => {
          if (!hasManagerAccess) {
            this.router.navigate(['/account']);
          }
          return hasManagerAccess;
        }),
        catchError((error: any, result: Observable<boolean>) => {
          console.error(error);
          return result;
        })
      );
    }
  }

  public canActivateChild(): Observable<boolean> {
    return this.canActivate();
  }

  public canLoad(): Observable<boolean> {
    return this.canActivate();
  }

  private checkStore(): Observable<boolean> {
    return this.store.select(fromStore.getAccountInformationLoaded).pipe(
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(new fromStore.LoadAccountInformation());
        }
      }),
      filter((loaded: boolean) => loaded),
      take(1)
    );
  }
}
